import ToolAlignment from './ToolAlignment';
import { type Alignment } from '../../../types/aha-editor';

class ToolAlignJustify extends ToolAlignment {
  static toolName = 'Justify';
  static iconClass = 'fa-regular fa-align-justify';
  static alignment: Alignment = 'justify';
  static shortcut = 'Cmd+Shift+j';
}

export default ToolAlignJustify;
